export default __webpack_public_path__ + "static/media/4.ea804524.jpg";